<template>
  <div class="data-list--row">
    <div class="row row--1"><slot name="col-title" /></div>
    <div class="row row--2"><slot name="col-value" /></div>
    <div class="row row--3"><slot name="col-qoq" /></div>
    <div class="row row--4"><slot name="col-yoy" /></div>
  </div>
</template>

<script>
export default {
  name: 'BrainsDataRow'
}
</script>

<style lang="scss" scoped>
.data-list--row {
  width: 100%;
  display: grid;
  justify-content: space-between;
  align-items: center;
  grid-template-columns: 55% 20% 12.5% 12.5%;

  .row {
    padding: 5px;
    text-align: left;
    font-size: 13px;

    & > div {
      display: flex;
      align-items: center;
    }

    &--1 {
      font-family: "Montserrat-SemiBold",sans-serif;
    }

    &--2 {
      font-family: "Montserrat-Light",sans-serif;
    }

    &--3 {
      font-family: "Montserrat-Light",sans-serif;
    }

    &--4 {
      font-family: "Montserrat-Light",sans-serif;
    }
  }
}
</style>
